import { MsalAuthProvider } from "react-aad-msal";

import { Environment, getConfiguration } from "../../config";
import { ApiClient } from "./ApiClient";

export class AzureApiClient extends ApiClient {
  private readonly authProvider: MsalAuthProvider;
  private jwtStr: string;

  constructor(authProvider: MsalAuthProvider, env?: Environment) {
    const config = getConfiguration(env);

    super({
      baseApiUrl: config.headerAuthWidgetsApiUrl,
      apiVersion: config.headerAuthWidgetsApiVersion,
      basePath: config.baseApiPath,
    });

    this.authProvider = authProvider;
  }

  async appendHeaders(): Promise<HeadersInit> {
    if (!this.authProvider) {
      Promise.reject("Auth provider does not setted");
    }

    const authHeader = await this.getAuthHeader();

    return Promise.resolve({ ...this.appJsonHeader, ...authHeader });
  }

  public async getAuthHeader(): Promise<HeadersInit> {
    if (!this.jwtStr || this.isExpiredJWT(this.jwtStr)) {
      const token = await this.authProvider.getIdToken();
      this.jwtStr = token.idToken.rawIdToken;
    }

    return Promise.resolve({ "auth-jwt": this.jwtStr });
  }
}
